import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useCampaignActionsEnabled } from '#src/app/pages/petitionDetails/shared/hooks';

import { usePetitionSignatureCount } from './petitionStats';

export function useNextStepButtonAction() {
	const {
		data: {
			petition: { slug, id },
		},
	} = usePetitionDetailsPageData();
	const {
		signatureCount: { displayed },
	} = usePetitionSignatureCount();
	const track = useTracking();
	const campaignActionsEnabled = useCampaignActionsEnabled();

	const comboLink = `/p/${slug}/psf/promote_or_share`;

	const handleNextStepClick = useCallback(() => {
		void track('petition_next_step_click', {
			petition_id: `petition_${id}`,
			signatureCount: displayed,
			campaignActionsEnabled,
		});
	}, [track, id, campaignActionsEnabled, displayed]);

	return {
		data: { comboLink },
		action: { handleNextStepClick },
	};
}
